import React, { Component } from 'react';
import { chooseAction } from '../actions/chooseAction';
import { executeAction } from '../actions/execute.action';
import GlobalStoreService from "./global-store.service";
import UtilService from "./util.service";
import { globalConstants } from "../constants/globalConstants";
import IdleTimeoutService from "./idle-timeout.service";
import UserActionType from '../enums/UserActionType'
import TrackingKey from '../enums/trackingKey'
import ChatHistoryService from "./chatHistory.service";
import TrackingMiddlewareService from './tracking-middleware.service'
import ScenarioType from '../enums/scenario-type';
import ChatActionType from '../enums/action-types/ChatActionType';
import BotSwitchService from './bot-switch.service';

export default class UserAction {

    static handleUserAction(userActionObject, messageComp) {
        // console.log(userActionObject)
        if (!messageComp.state.disableOptionClicks) {
            messageComp.setState({ fieldType: globalConstants.INPUT_FIELD_TYPES.CHAT })
            IdleTimeoutService.updateIdleState();

            UserAction.addMessagesToChat(userActionObject, messageComp)

            let chatBotQuery = UserAction.getChatBotQuery(userActionObject)

            UserAction.handleUserActionTracking(userActionObject, messageComp.state.current_scenario)

            if (userActionObject.actionType !== UserActionType.RETRY_CLICK) {
                messageComp.clearRetry()
            }

            if (true) {
                messageComp.scrollToBottom();

                messageComp.clearResponseOptions();
                messageComp.hideFeedbackOptions();

                UserAction.handleApiRequests(userActionObject, messageComp, chatBotQuery)
            }

        }
    }


    static addMessagesToChat(userActionObject, messageComp) {
        let new_messages = []
        let switchScenarioMessages = []
        if (userActionObject && !userActionObject.afterBotSwitch) {
            new_messages = UserAction.getChatMessagesOnUserAction(userActionObject)
        }
        if (userActionObject.actionType === UserActionType.SNS_CLICKED) {
            if (userActionObject.snsObject.scenarioStrategy && userActionObject.snsObject.scenarioStrategy === ScenarioType.SwitchScenario) {
                switchScenarioMessages = UserAction.handleSwitchScenario(userActionObject.snsObject, messageComp)
            }
        }

        new_messages && new_messages.length > 0 && messageComp.addNewMessages({ new_messages: [...new_messages, ...switchScenarioMessages] })
    }

    static handleApiRequests(userActionObject, messageComp, chatBotQuery) {

        switch (userActionObject.actionType) {
            case (UserActionType.FEEDBACK_CLICK): {
                let scenarioObject = GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")][userActionObject.inputQuery]
                UserAction.sendApiRequest({ actionType: userActionObject.actionType, user_response: chatBotQuery, scenarioResponse: scenarioObject }, messageComp, chatBotQuery)
                break;
            }
            case (UserActionType.CATEGORY_OPTION_CLICKED): {

                if (userActionObject.categoryObject.scenarioResponse && userActionObject.categoryObject.scenarioStrategy === ScenarioType.FAQScenario) {
                    messageComp.setState({ disableInputField: false })
                    messageComp.showFeedbackOptions();
                    return
                }
                if (userActionObject.categoryObject.scenario && userActionObject.categoryObject.scenarioStrategy === ScenarioType.DTScenario) {
                    UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CATEGORY, user_response: chatBotQuery, scenarioResponse: userActionObject.categoryObject.scenario }, messageComp, chatBotQuery)
                }
                else {
                    UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CATEGORY, user_response: chatBotQuery }, messageComp, chatBotQuery)
                }
                break;
            }
            case (UserActionType.CHAT_TEXT_ENTER): {
                UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.DEFAULT, user_response: chatBotQuery, user_res: chatBotQuery }, messageComp, chatBotQuery)
                break;
            }
            case (UserActionType.CHOICE_CLICKED): {

                if (userActionObject.inputQuery === 'Previous Step') {
                    ChatHistoryService.goToPrevious(messageComp);
                }
                else if (messageComp.state.current_scenario &&
                    messageComp.state.current_scenario.scenarioType &&
                    messageComp.state.current_scenario.scenarioType === "ASK_NUMBER_CONFIRMATION_WEB"
                ) {
                    UserAction.handleAskNumberConfirmationForSingleAccountWeb(chatBotQuery, messageComp);
                }
                else {
                    UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CHOICE_CLICKED, user_response: chatBotQuery, user_res: chatBotQuery, scenarioResponse: messageComp.state.current_scenario }, messageComp, chatBotQuery)
                }
                break;
            }
            case (UserActionType.COUNTRY_SELECT): {
                UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.COUNTRY_SELECT, user_response: chatBotQuery, user_res: chatBotQuery, scenarioResponse: messageComp.state.current_scenario }, messageComp, chatBotQuery)
                break;
            }
            case (UserActionType.SNS_CLICKED): {
                let snsObject = userActionObject.snsObject
                if (snsObject.scenarioStrategy && snsObject.scenarioStrategy === ScenarioType.FAQScenario && snsObject.scenarioResponse) {
                    messageComp.setState({ disableInputField: false })
                    messageComp.showFeedbackOptions();
                    return
                }
                else if (snsObject.scenarioObject && snsObject.scenarioStrategy && snsObject.scenarioStrategy === ScenarioType.DTScenario) {
                    UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CHAT, user_response: chatBotQuery, user_res: chatBotQuery, scenarioResponse: userActionObject.snsObject.scenarioObject.scenario }, messageComp, chatBotQuery)
                }
                else if (snsObject.scenarioStrategy && snsObject.scenarioStrategy === ScenarioType.SwitchScenario) {
                    // nothing
                }
                else {
                    UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CHAT, user_response: chatBotQuery, user_res: chatBotQuery }, messageComp, chatBotQuery)
                }
                break;
            }
            case (UserActionType.RETRY_CLICK): {

                messageComp.retry_count = messageComp.retry_count + 1
                let query = UserAction.getChatBotQuery(messageComp.state.userActionObject)
                UserAction.handleApiRequests(messageComp.state.userActionObject, messageComp, query)
                messageComp.setState({ show_retry: false })

                break;
            }
            case (UserActionType.CREATE_SR): {
                // console.log(userActionObject, chatBotQuery)
                UserAction.sendApiRequest({ actionType: ChatActionType.CREATE_SR, user_response: chatBotQuery, user_res: chatBotQuery, scenarioResponse: messageComp.state.current_scenario, aditionalData: userActionObject.additionalData }, messageComp, chatBotQuery)
                // UserAction.sendApiRequest({ actionType: globalConstants.USER_ACTION_TYPES.CREATE_SR, user_response: chatBotQuery, user_res: chatBotQuery, scenarioResponse: messageComp.state.current_scenario, aditionalData: userActionObject.aditionalData }, messageComp, chatBotQuery)
                break;
            }
        }
    }

    static handleAskNumberConfirmationForSingleAccountWeb = (chatBotQuery, messageComp) => {

        if ((chatBotQuery).toLowerCase() !== "no") {
            // Number confirmed and initiate welcome scenario
            GlobalStoreService.set("isUserLoggedIn", true);
            GlobalStoreService.set("currentNumber", GlobalStoreService.get("primaryNumber"));
            messageComp.onNumberSelected({ user_response: 'Yes', show_number: true });
            messageComp.enableBottomBar();

        } else {
            // User is logged off and initiate welcome scenario
            messageComp.enableBottomBar();
            GlobalStoreService.set("isUserLoggedIn", false);
            GlobalStoreService.set("loggedInToken", null);
            GlobalStoreService.set("currentNumber", GlobalStoreService.get("primaryNumber"));
            messageComp.onNumberSelected({ user_response: 'No', show_number: true });
        }
        return;
    }


    static sendApiRequest({ user_response, scenarioResponse, actionType, user_res, aditionalData }, messageComp, chatBotQuery) {

        messageComp.setLoaderOn();
        messageComp.scrollToBottom();
        messageComp.disableOptionClicks(true);

        const selectedAction = chooseAction({
            scenarioResponse: (actionType === globalConstants.USER_ACTION_TYPES.DEFAULT || actionType === globalConstants.USER_ACTION_TYPES.PLACE) ? messageComp.state.current_scenario : scenarioResponse,
            data: {
                user_response: user_response ? user_response : null,
                actionType: actionType ? actionType : null,
                user_res: (user_res) ? user_res : null,
                aditionalData: aditionalData ? aditionalData : null
            }
        });
        // console.log('action selected', selectedAction)
        if (selectedAction) {
            const resultantComponentPromise = executeAction(
                selectedAction,
                {
                    scenarioResponse: (actionType === globalConstants.USER_ACTION_TYPES.DEFAULT) ? messageComp.state.current_scenario : scenarioResponse,
                    user_response: user_response
                },
                messageComp.retry_count, chatBotQuery)
            resultantComponentPromise.then(
                (response) => {
                    messageComp.handleResponseAfterExecution({ response, user_response, actionType, user_res, scenarioResponse, aditionalData });

                }, (error) => {
                    messageComp.handleErrorAfterExecution(error, selectedAction)

                });
        }
    }

    static getChatBotQuery(userActionObject) {
        let inputQuery = userActionObject.inputQuery;
        let actionType = userActionObject.actionType;
        let categoryObject = userActionObject.categoryObject;
        let snsObject = userActionObject.snsObject;

        switch (actionType) {
            case (UserActionType.FEEDBACK_CLICK): {
                return inputQuery
            }
            case (UserActionType.CATEGORY_OPTION_CLICKED): {
                if (categoryObject.scenarioResponse) {
                    return null
                }
                return categoryObject.scenarioTitle
            }
            case (UserActionType.COUNTRY_SELECT): {
                return snsObject.shortKey
            }
            case (UserActionType.SNS_CLICKED): {
                return snsObject.shortKey
            }
            case (UserActionType.CHAT_TEXT_ENTER):
            case (UserActionType.CHOICE_CLICKED):
            default: {
                return inputQuery
            }
        }
    }

    static getChatMessagesOnUserAction(userActionObject) {

        let inputQuery = userActionObject.inputQuery;
        let shownQuery = userActionObject.shownQuery;
        let actionType = userActionObject.actionType;
        let categoryObject = userActionObject.categoryObject;
        let snsObject = userActionObject.snsObject;

        let messages = []
        switch (actionType) {
            case (UserActionType.FEEDBACK_CLICK): {
                messages.push(UtilService.createUserMessageObject(inputQuery, true))
                break;
            }
            case (UserActionType.CATEGORY_OPTION_CLICKED): {
                messages.push(UtilService.createUserMessageObject(categoryObject.scenarioTitle))
                if (categoryObject.scenarioResponse) {
                    messages.push(UtilService.createChatBotMessageObject(categoryObject.scenarioResponse))
                }
                break;
            }
            case (UserActionType.COUNTRY_SELECT): {
                messages.push(UtilService.createUserMessageObject(snsObject.longKey))
                break;
            }
            case (UserActionType.SNS_CLICKED): {
                messages.push(UtilService.createUserMessageObject(snsObject.longKey))
                if (snsObject.scenarioStrategy && snsObject.scenarioStrategy === ScenarioType.FAQScenario && snsObject.scenarioResponse) {
                    messages.push(UtilService.createChatBotMessageObject(snsObject.scenarioResponse))
                }
                break;
            }
            case (UserActionType.CHAT_TEXT_ENTER):
            case (UserActionType.CHOICE_CLICKED): {
                messages.push(UtilService.createUserMessageObject(shownQuery))
                break;
            }
            default: { }
        }
        return messages
    }

    static handleUserActionTracking = (userActionObject, Scenario) => {

        if (userActionObject.actionType !== UserActionType.FEEDBACK_CLICK) {
            let feedbackSkippedTracking = UserAction.checkForFeedbackSkippedTracking(userActionObject, Scenario)

            if (feedbackSkippedTracking) {
                TrackingMiddlewareService.trackEvent(feedbackSkippedTracking)
            }
        }

        if (UtilService.isBadFeedbackScenario(Scenario)) {
            UserAction.setTrackingDataOnUserAction(userActionObject, true)
        }
        else {
            UserAction.setTrackingDataOnUserAction(userActionObject)
        }

        switch (userActionObject.actionType) {
            case (UserActionType.FEEDBACK_CLICK): {

                if (userActionObject.inputQuery && userActionObject.inputQuery == "GOOD_FEEDBACK") {
                    TrackingMiddlewareService.trackEvent(TrackingKey.FEEDBACK_HAPPY)
                } else {
                    TrackingMiddlewareService.trackEvent(TrackingKey.FEEDBACK_SAD)
                }

                break;
            }
            case (UserActionType.CATEGORY_OPTION_CLICKED): {

                TrackingMiddlewareService.trackEvent(TrackingKey.SCENARIO_QUERY)

                break;
            }
            case (UserActionType.SNS_CLICKED): {
                if (userActionObject.snsObject.scenarioStrategy && userActionObject.snsObject.scenarioObject) {

                    TrackingMiddlewareService.trackEvent(TrackingKey.INTENT_READING_SUCCESS)
                }
                break;
            }
            case (UserActionType.CHOICE_CLICKED): {

                if (UserAction.isBadFeedbackScenario(Scenario)) {
                    TrackingMiddlewareService.trackEvent(TrackingKey.IMPROVE_FEEDBACK)
                }

                if (UserAction.isGridClickScenario(Scenario)) {
                    TrackingMiddlewareService.trackEvent(TrackingKey.GRID_CLICKS)
                }

                break;
            }
            default: { }
        }
    }

    static setTrackingDataOnUserAction = (userActionObject, isSuggestion) => {

        let enteredTextMode, user_suggestion, user_response, scenarioName, scenarioStrategy

        switch (userActionObject.actionType) {
            case UserActionType.CATEGORY_OPTION_CLICKED: {
                enteredTextMode = 'click'
                user_response = userActionObject.categoryObject.scenarioTitle
                scenarioName = userActionObject.categoryObject.scenarioTitle
                scenarioStrategy = userActionObject.categoryObject.scenarioStrategy || 'DTScenario'

                break;
            }
            case UserActionType.CHOICE_CLICKED: {
                enteredTextMode = 'click'
                if (isSuggestion)
                    user_suggestion = userActionObject.inputQuery
                else
                    user_response = userActionObject.inputQuery
                break;
            }
            case UserActionType.COUNTRY_SELECT: {
                enteredTextMode = 'click'
                user_response = userActionObject.snsObject.shortKey
                scenarioName = userActionObject.snsObject.longKey

                break;
            }
            case UserActionType.CHAT_TEXT_ENTER: {
                enteredTextMode = 'write'
                user_response = userActionObject.inputQuery

                break;
            }
            case UserActionType.SNS_CLICKED: {
                enteredTextMode = 'click'
                user_response = userActionObject.snsObject.shortKey,
                    scenarioName = userActionObject.snsObject.longKey

                break;
            }
        }

        TrackingMiddlewareService.setTrackingData({ enteredTextMode, user_response, user_suggestion, scenarioName, scenarioStrategy })

    }

    static checkForFeedbackSkippedTracking = (userActionObject, Scenario) => {

        if (document.getElementById("feedback-up")) {
            return TrackingKey.FEEDBACK_SKIPPED
        }
        if (((userActionObject && userActionObject.actionType !== UserActionType.CHOICE_CLICKED) || !userActionObject) && UserAction.isBadFeedbackScenario(Scenario) && Scenario.scenarioActive) {
            return TrackingKey.IMPROVE_FEEDBACK_SKIPPED
        }
        else
            return undefined

    }

    static isBadFeedbackScenario = (Scenario) => {

        if (Scenario && Scenario.scenario && Scenario.scenario.scenarioId === GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]['BAD_FEEDBACK'].scenarioId) {
            return true
        }
        else
            return false
    }

    static isGridClickScenario = (current_scenario) => {
        let isGridClickScenario = false
        if (current_scenario && current_scenario.scenario && current_scenario.scenario.scenarioId) {
            switch (current_scenario.scenario.scenarioId) {
                case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["WELCOME"].scenarioId:
                case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["FAILURE"].scenarioId:
                case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_1"].scenarioId:
                case GlobalStoreService.get("scenarioList")[GlobalStoreService.get("currentBotType")]["NO_INTENT_FOUND_2"].scenarioId:
                    {
                        isGridClickScenario = true
                        break;
                    }
            }
        }
        return isGridClickScenario
    }

    static handleSwitchScenario = (snsObject, messageComp, chatBotQuery) => {
        //switch the bot 
        let message_objects = []
        let newBotType = snsObject.scenarioObject.scenario.scenarioLob
        if(BotSwitchService.checkIfLobEnabled(newBotType)){

            if (GlobalStoreService.get('isUserLoggedIn')) {

                if (GlobalStoreService.get('userProfile')) {
                    let userProfile = GlobalStoreService.get('userProfile')
                    let accounts = UtilService.getAccountsForBotType(userProfile, newBotType)
                    if (accounts && accounts.length > 0) {
    
                        message_objects = [{
                            component_type: 'DEFAULT',
                            message: `Hey!! You have enquired about a ${newBotType && newBotType.toLowerCase()} number.Please switch to a ${newBotType.toLowerCase()} number and ask your query!`,
                            messageTime: UtilService.getCurrentTime()
                        }]
                    }
                    else {
                        //no new bot type number in user profile
                        message_objects = [{
                            component_type: 'DEFAULT',
                            message: `Hey!! You have enquired about a ${newBotType && newBotType.toLowerCase()} number, currently no ${newBotType && newBotType.toLowerCase()} numbers are added into your profile.`,
                            messageTime: UtilService.getCurrentTime()
                        }]
                    }
                }
                else {
                    // no user profile found
                    GlobalStoreService.set('isUserLoggedIn', false)
                    GlobalStoreService.set('loggedInToken', null)
                    GlobalStoreService.set('currentBotType', snsObject.scenarioObject.scenario.scenarioLob.toUpperCase())
                    messageComp.initiateWelcomeScenarioForCurrentBot()
                }
            }
            else {
                // handle if logged out
                GlobalStoreService.set('currentBotType', snsObject.scenarioObject.scenario.scenarioLob.toUpperCase())
                messageComp.initiateWelcomeScenarioForCurrentBot()
            }
        }
        else{
            snsObject['searchReply'] =  snsObject.scenarioObject
            message_objects = BotSwitchService.getChatMessageIfBotLobDisabled(snsObject,newBotType)
        }
        return message_objects

    }

    static createUserMessageObject = (message, is_feedback) => {
        return {
            component_type: 'USER_RESPONSE',
            message: message,
            messageTime: UtilService.getCurrentTime(),
            is_feedback
        }
    }

    static createChatBotMessageObject = (message) => {
        return {
            component_type: 'DEFAULT',
            message: message,
            messageTime: UtilService.getCurrentTime()
        }
    }
}


// WEBPACK FOOTER //
// ./src/services/handle-user-action.service.js